import { t } from "@web-monorepo/i18n/macro";
import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import { getImageSrc } from "@web-monorepo/static-assets";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";

const icon = getImageSrc("toolkit/src/pods/noise/assets/logo.svg");

export const appMetadataNoise = (): AppMetadata => ({
  href: "noise",
  title: t`Noise Meter`,
  variant: "noise",
  icon,
});

export type NoiseState = {
  gain: number;
  microphonePermissionErrorName: string;
  showSensitivityInput?: boolean;
};

export const initialNoiseState: NoiseState = {
  gain: 0,
  microphonePermissionErrorName: "NotAllowedError",
};

type Payload = { gain: number };

export const SEND_NOISE = createAction("SEND_NOISE");
export const RECEIVE_NOISE = createAction("RECEIVE_NOISE");
export const SEND_MICROPHONE_PERMISSION_ERROR = createAction("SEND_MICROPHONE_PERMISSION_ERROR");
export const RECEIVE_MICROPHONE_PERMISSION_ERROR = createAction("RECEIVE_MICROPHONE_PERMISSION_ERROR");

export const sendNoise = createActionCreator(SEND_NOISE, (payload: Payload) => payload);

// can pass null to clear the error
export const sendMicrophonePermissionError = createActionCreator(SEND_MICROPHONE_PERMISSION_ERROR, (errorName) => ({
  errorName,
}));
